'use client';

import React from 'react';
import styled from 'styled-components';

import useTranslation from '../translation/useTranslation';

export interface CooperationProps {
  organization: string
  logo?: {
    src: string
    height: string
  }
}

function Cooperation({
  organization,
  logo,
}: CooperationProps) {
  const { t } = useTranslation();

  const text = t('cooperation.text');

  return (
    <CooperationBase>
      <p>{text}</p>
      <img
        alt={organization}
        {...logo}
      />
    </CooperationBase>
  );
}

export default Cooperation;

export const CooperationBase = styled.div`
  grid-area: below;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  color: var(--navbar-color, #292929);

  padding: 8px 16px;

  line-height: 24px;

  & > p {
    margin: 0;
    color: inherit;
  }
`;
